import React from 'react';
import proPic from '../../image/1613568929202-01-removebg-preview.png';
import './About.css'
const About = () => {
    return (
        <div className='container mt-1'>
          <div className='row d-flex align-items-center'>
                <div className='col-md-6'>
                    <img src={proPic} alt="" className='img-fluid' data-aos="fade-right" data-aos-offset="200" data-aos-easing="ease-in-sine" />
                </div>
                <div className='col-md-6 aboutLeftSection' data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
                    <h2 className='fw-bold mt-4 font-monospace'>About Me</h2>
                    <p className='aboutText'>
                       A self-motivated and passionate front end developer with a deep interest in software development world.Work with modern technologies of different local & multinational Software/ IT firm and grow rapidly with increasing responsibilities. I am easy to communicate with and good with teamwork. Looking forward to build career in software industry. Also I love to teach and share knowledge to everyone 
                    </p>
                </div>
          </div>
          
        </div>
    );
};

export default About;